import React from "react";
import { Loader } from "@/components/ui/loader";

interface Props {
  progressPercentage: number;
}

export const ProgressIndicator: React.FC<Props> = ({ progressPercentage }) => (
  <div className="mt-3 flex items-center gap-2.5 rounded-md bg-coral/10 px-3 py-2">
    <Loader className="h-4 w-4 text-coral" />
    <div className="flex-1">
      <div className="mb-1 flex items-center justify-between text-xs">
        <span className="font-medium text-coral">Generating content</span>
        <span className="text-coral/80">{progressPercentage}%</span>
      </div>
      <div className="h-1.5 overflow-hidden rounded-full bg-coral/20">
        <div className="h-full bg-coral transition-all duration-300" style={{ width: `${progressPercentage}%` }} />
      </div>
    </div>
  </div>
);
